import { NuqsAdapter } from 'nuqs/adapters/react';

import { Dashboard } from '@pages/Dashboard/Dashboard';

import { registerHardcodedDashboardResponsePatch } from '../../lib/registerHardcodedDashboardResponsePatch';
import { registerHardcodedDashboardRoutes } from '../../model/routes';

import type { TDealDetails } from '@crm/entities/deal';

interface DealProjectDashboardProps {
    projectData: NonNullable<TDealDetails['projectData']>;
}

export const DealProjectDashboard = ({ projectData }: DealProjectDashboardProps) => {
    const projectId = projectData.projectId ?? projectData.id;

    if (!Number.isFinite(projectId)) {
        return null;
    }

    registerHardcodedDashboardRoutes(projectId);
    registerHardcodedDashboardResponsePatch(projectId);

    return (
        <div data-deal-project-id={projectData.id} data-project-id={projectId}>
            <h2 className="mb-5 justify-start text-base leading-5 font-bold text-smtr-main-black-100">
                Об объекте
            </h2>
            <NuqsAdapter>
                <div className="smetter-css dashboard-css">
                    <Dashboard key={projectId} projectId={projectId} variant="embedded" />
                </div>
            </NuqsAdapter>
        </div>
    );
};
